/* eslint-disable @typescript-eslint/no-explicit-any */

export function groupByField<
  T extends Record<K, string | any>,
  K extends keyof T
>(items: T[], groupBy: K) {
  return items.reduce((rv, x) => {
    (rv[x[groupBy]] = rv[x[groupBy]] || []).push(x);
    return rv;
  }, {} as { [group: string]: T[] });
}

export function groupByFunc<
  T extends Record<K, string | any> | string,
  K extends string
>(items: T[], groupBy: (item: T) => K) {
  return items.reduce((rv, x) => {
    (rv[groupBy(x)] = rv[groupBy(x)] || []).push(x);
    return rv;
  }, {} as { [group: string]: T[] });
}
